import { z } from "zod";

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_ENVIRONMENT: z.string().default("development"),
  VITE_APP_URL: z.string().url().default("http://localhost:5173"),
  VITE_SUPPORT_EMAIL: z.string().email().default("support@super-pari.sn"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // eslint-disable-next-line no-console
  console.error("❌ Invalid env variables:", parsed.error.flatten().fieldErrors);
  throw new Error("Invalid environment variables. Check .env.example");
}

export const env = parsed.data;
